<script>
	import icons from './images';
	let { name, class: className } = $props();
</script>

<div class={['inline-block', className]}>
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html icons[name]}
</div>
